import React from 'react';
import { ApartmentCard } from './ApartmentCard';
import { DecorativeBorder } from './DecorativeElements';
export function Apartments() {
  const apartments = [{
    name: 'Dream',
    image: 'https://res.cloudinary.com/dfu9nzn8r/image/upload/v1771582196/soggiornocondivanola_centro_tuxcob.jpg',
    description: 'A sun-drenched sanctuary overlooking the ancient olive groves. Wake up to the sound of cicadas and the scent of wild rosemary.',
    features: ['King Size Bed', 'Private Terrace', 'Garden View', 'En-suite Bath'],
    rotation: '-2deg'
  }, {
    name: 'Heaven',
    image: 'https://res.cloudinary.com/dfu9nzn8r/image/upload/v1771582024/VillaWaca_Owner_026_lmhalr.jpg',
    description: 'Our most intimate retreat. Stone walls that whisper history, keeping you cool in the summer heat. A perfect romantic hideaway.',
    features: ['Queen Bed', 'Stone Architecture', 'Private Entrance', 'Kitchenette'],
    rotation: '1deg'
  }, {
    name: 'Oasis',
    image: 'https://res.cloudinary.com/dfu9nzn8r/image/upload/v1771582022/VillaWaca_Owner_09_swyvdi.jpg',
    description: 'Spacious and airy, where the indoors meets the outdoors. Perfect for families who want to live the true Apulian lifestyle.',
    features: ['Two Bedrooms', 'Full Kitchen', 'Large Patio', 'Dining Area'],
    rotation: '3deg'
  }];
  return <section id="apartments" className="py-24 px-4 bg-paper-texture-dark overflow-hidden scroll-mt-24" data-id="element-80">
      <div className="max-w-7xl mx-auto" data-id="element-81">
        <div className="text-center mb-16" data-id="element-82">
          <h2 className="text-4xl md:text-5xl text-[var(--brown)] mb-4" data-id="element-83">
            Le Nostre Case
          </h2>
          <p className="font-script text-2xl text-[var(--sienna)]" data-id="element-84">
            Our Homes
          </p>
          <div className="w-32 mx-auto mt-6" data-id="element-85">
            <DecorativeBorder className="w-full text-[var(--sage)]" data-id="element-86" />
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-12 md:gap-8 items-center justify-items-center perspective-1000" data-id="element-87">
          {apartments.map((apt, index) => <ApartmentCard key={apt.name} {...apt} className={`transform transition-all duration-500 hover:z-20 ${index === 1 ? 'md:-translate-y-8' : ''}`} data-id="element-88" />)}
        </div>
      </div>
    </section>;
}